// Tile catalog. We use a curated subset (TILE_TYPES) so matches feel
// frequent on a small board. The full catalog is here for future
// level-specific variant pools / boosters.
export const TILE_META = {
  brain:     { name: "Brain",     accent: "#ff6b9e" },
  skull:     { name: "Skull",     accent: "#e8d6a8" },
  bone:      { name: "Bone",      accent: "#d8c89a" },
  flask:     { name: "Flask",     accent: "#7ed957" },
  barrel:    { name: "Barrel",    accent: "#ffd06b" },
  dna:       { name: "DNA",       accent: "#5ee8ff" },
  meat:      { name: "Meat",      accent: "#ff5b6b" },
  tombstone: { name: "Tombstone", accent: "#a5a5a5" },
  eyeball:   { name: "Eyeball",   accent: "#9eff5e" },
  hand:      { name: "Hand",      accent: "#84d96f" },
  heart:     { name: "Heart",     accent: "#5a4a6a" },
  spider:    { name: "Spider",    accent: "#cc3030" },
  gasmask:   { name: "Gas Mask",  accent: "#7a8a3c" },
  radiation: { name: "Radiation", accent: "#ffd06b" },
};

// Active match-3 pool — 6 most visually distinct tiles (different colors,
// different shapes). Using a curated 6 keeps match-3 hits frequent on a
// 7x7 board (~50% chance of having matches after any swap).
export const ACTIVE_TILES = ["brain", "skull", "flask", "dna", "meat", "tombstone"];

const IMG = (() => {
  const map = {};
  try {
    const ctx = require.context("./tiles", false, /\.(png|webp|jpg|jpeg)$/);
    ctx.keys().forEach((key) => {
      const m = key.match(/([a-z]+)\.(png|webp|jpg|jpeg)$/i);
      if (!m) return;
      const mod = ctx(key);
      map[m[1]] = mod && mod.default ? mod.default : mod;
    });
  } catch (_e) { /* no folder yet */ }
  return map;
})();

export function tileImg(type) { return IMG[type] || null; }
export function tileMeta(type) { return TILE_META[type] || { name: type, accent: "#a569ff" }; }
